module.exports = "/_next/static/images/ntuc-link-trust-visa-card-b85fa00b7b85dd638c77e3f2e459901d.png";